import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { LocalStorageService } from './types/local-storage-service.interface';
import { LocalStorageServiceImpl } from './local-storage-service';
export const localStorage = new ContainerModule(bind => {
    bind(LocalStorageService).to(LocalStorageServiceImpl);
});
